import {Component} from '@angular/core';
import {ParametersService, SubtitlesService} from "../core";

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent {
    fullYear: number;

    constructor(
        public subtitles: SubtitlesService,
        public parameters: ParametersService
    ) {
        this.fullYear = new Date().getFullYear();
    }

    showDefaultFooter(): boolean {
        const companies = ['polypipe', 'elias', 'jawo', 'klimor', 'roth'];
        return !companies.includes(this.parameters.urlCompany);
    }
}
